'use strict';

export function ConditionallyDisplayedElement(element) {
    const dataset = element.dataset;
    const condition = dataset ? dataset.displayIf : null;

    if (condition) {
        const triggerSupportAttributeName = 'data-' + condition.replace(/([a-zA-Z])(?=[A-Z])/g, '$1-').toLowerCase();
        const triggerSupportElement = document.querySelector('[' + triggerSupportAttributeName + ']');

        if (triggerSupportElement) {
            element.style.display = triggerSupportElement.dataset[condition] === 'false' ? 'none' : '';

            const observer = new MutationObserver(function (mutations) {
                for (let i = 0; i < mutations.length; i++) {
                    if (mutations[i].attributeName === triggerSupportAttributeName) {
                        element.style.display = triggerSupportElement.dataset[condition] === 'false' ? 'none' : '';
                    }
                }
            });

            const observerConfig = {
                attributes: true,
                childList: false,
                characterData: false
            };

            observer.observe(triggerSupportElement, observerConfig);
        }
    }

    return element;
}
